// imports section Start
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import { useSelector, useDispatch } from "react-redux";
import { Box, Typography, Divider, Grid } from "@mui/material";
import { formatDate, formatTime } from "../../../utils/common/DateFormat";
// imports section End

function CashReceiptBodyA4({
  billOptions,
  mappedOptions,
  orderPayload,
  source,
}) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // const formattedDate = formatDate(orderDetails?.[0]?.GROSSAMOUNT);

  // Handlers start
  function formatPrice(value) {
    if (typeof value === "number") {
      return value
        .toFixed(2) // Ensure two decimal places
        .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Add thousand separators
    }
    return value;
  }

  const {
    Table1: orderDetails = [], // Rename Table1 to orderSummary
    Table2: itemCharges = [], // Rename Table2 to itemDetails
    Table3: cartItems = [], // Rename Table3 to totals
  } = orderPayload || {};

  const priceDetails = [
    {
      label: "Gross Amount",
      value: formatPrice(orderDetails?.[0]?.GROSSAMOUNT) || "0.00",
    },
    {
      label: "Discount Amount",
      value: formatPrice(orderDetails?.[0]?.DISCOUNT) || "0.00",
    },
    {
      label: "Loyalty Amount",
      value: formatPrice(orderDetails?.[0]?.LOYALTYAMOUNT) || "0.00",
    },
    {
      label: "Cash Paid",
      value: formatPrice(orderDetails?.[0]?.CASHAMOUNT) || "0.00",
    },
    {
      label: "Card Paid",
      value: formatPrice(orderDetails?.[0]?.CARDAMOUNT) || "0.00",
    },
    // {
    //   label: "Buffet Charges",
    //   value: orderDetails?.[0]?.GROSSAMOUNT || "$0.00",
    // },
    // {
    //   label: "Tax Amount",
    //   value: formatPrice(serviceTax?.CTAMOUNT) || "0.00",
    // },
    {
      label: "Tax Amount",
      value: formatPrice(orderDetails?.[0]?.TAXAMOUNT) || "0.00",
    },
    {
      label: "Charge Amount",
      value: formatPrice(orderDetails?.[0]?.CHARGEAMOUNT) || "0.00",
    },

    {
      label: "Adjust Amount",
      value: formatPrice(orderDetails?.[0]?.ADJUSTAMOUNT) || "0.00",
    },
    {
      label: "Bill Amount",
      value: formatPrice(orderDetails?.[0]?.BILLAMOUNT) || "0.00",
    },
    {
      label: "Advance Amount",
      value: formatPrice(orderDetails?.[0]?.ADVANCEAMOUNT) || "0.00",
    },
    {
      label: "Total Paid Amount",
      value: formatPrice(orderDetails?.[0]?.PAIDAMOUNT) || "0.00",
    },

    {
      label: "Balance Amount",
      value: formatPrice(orderDetails?.[0]?.BALANCEAMOUNT) || "0.00",
    },
    // {
    //   label: "Credit Amt.",
    //   value: formatPrice(orderDetails?.[0]?.CREDITDUEAMOUNT) || "0.00",
    //   // highlight: false,
    // },
  ];

  const taxnchargeDetails = [
    ...itemCharges.map((charge) => ({
      label: charge.CTTYPE,
      value: formatPrice(charge.CTAMOUNT),
      cttype: formatPrice(charge.CORT),
    })),
  ];

  // Only add "Credit Amt." if this is a PlaceOrder bill
  if (source === "CashierSummery") {
    priceDetails.push({
      label: "Credit Amount",
      value:
        formatPrice(
          orderDetails?.[0]?.BILLAMOUNT -
            (orderDetails?.[0]?.ADVANCEAMOUNT || "0.00")
        ) || "0.00",
    });
  }

  const filteredPriceDetails = priceDetails.filter(
    (detail) => detail.value && detail.value !== "0.00"
  );
  const tableName = orderDetails?.[0]?.TABLENAME;
  // Handlers end
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 1,
        }}
      >
        <Grid container>
          {/* Invoice Header */}
          {mappedOptions.has(6) && (
            <Grid item xs={12} mb={1} textAlign="center">
              <Typography
                variant="body2"
                fontWeight={500}
                color={theme.palette.text.tertiary}
              >
                Order No : {orderDetails?.[0]?.ORDERCODE}
              </Typography>
              <Divider
                sx={{
                  marginY: 1,
                  borderBottomWidth: 2,
                  borderStyle: "dotted",
                }}
              />
            </Grid>
          )}
          {mappedOptions.has(7) && (
            <Grid item xs={12} mb={1} textAlign="center">
              <Typography variant="body1" fontWeight={600}>
                INVOICE NO : {orderDetails?.[0]?.INVNO}
              </Typography>
              {/* <Typography
                  variant="body2"
                  fontWeight={500}
                  color={theme.palette.text.tertiary}
                >
                  Order No : {orderDetails?.[0]?.INVNO}
                </Typography> */}
              <Divider
                sx={{
                  marginY: 1,
                  borderBottomWidth: 2,
                  borderStyle: "dotted",
                }}
              />
            </Grid>
          )}

          {/* Order Information */}
          {[
            {
              label: "Order Type",
              value: orderDetails?.[0]?.ORDERTYPE,
              key: 8,
            },
            {
              label: "Customer",
              value: orderDetails?.[0]?.GUESTNAME,
              key: 9,
            },
            { label: "KOT No.", value: orderDetails?.[0]?.KOTCODE, key: 10 },
            {
              label: "Order Date",
              value: formatDate(orderDetails?.[0]?.PAYDATE),
              key: 11,
            },
            {
              label: "Invoice Date",
              value: formatDate(orderDetails?.[0]?.ORDERENDATE),
              key: 12,
            },
            {
              label: "Delivery Date",
              value: formatDate(orderDetails?.[0]?.DELIVERYDATE),
              key: 13,
            },
            {
              label: "Table",
              value:
                typeof orderDetails?.[0]?.TABLENAME === "string"
                  ? orderDetails[0].TABLENAME
                  : orderDetails?.[0]?.TABLENAME?.name || "N/A",
              key: 14,
            },
            { label: "Operator", value: orderDetails?.[0]?.ENUSER, key: 15 },
            {
              label: "Officer",
              value: orderDetails?.[0]?.OPOFFICER || "N/A",
              key: 16,
            },
          ]
            .filter((item) => mappedOptions.has(item.key)) // Filter active options
            .reduce((rows, item, index, array) => {
              if (index % 2 === 0) rows.push(array.slice(index, index + 2)); // Group into rows
              return rows;
            }, [])
            .map((row, rowIndex) => (
              <Grid container key={rowIndex} mb={1}>
                {row.map((col, colIndex) => (
                  <Grid
                    item
                    xs={6}
                    key={colIndex}
                    sx={colIndex % 2 === 1 ? styles.cr_right_align : {}}
                  >
                    <Typography variant="body2" fontWeight={600}>
                      {col.label}
                    </Typography>
                    <Typography variant="body2">{col.value}</Typography>
                  </Grid>
                ))}
              </Grid>
            ))}

          {/* Footer */}
          {/* {mappedOptions.has(17) && (
            <Grid item xs={12} mb={1} textAlign="center">
              <Divider
                sx={{
                  marginY: 1,
                  borderBottomWidth: 2,
                  borderStyle: "dotted",
                }}
              />
              <Typography variant="body2" fontWeight={600}>
                {orderDetails?.[0]?.HEADER}
              </Typography>
              <Divider sx={{ marginY: 1 }} />
            </Grid>
          )} */}

          {mappedOptions.has(17) &&
            orderDetails?.[0]?.HEADER &&
            Object.keys(orderDetails[0].HEADER).length > 0 && (
              <Grid item xs={12} mb={1} textAlign="center">
                <Divider
                  sx={{
                    marginY: 1,
                    borderBottomWidth: 2,
                    borderStyle: "dotted",
                  }}
                />
                <Typography variant="body2" fontWeight={600}>
                  {JSON.stringify(orderDetails[0].HEADER)}{" "}
                </Typography>

                <Divider sx={{ marginY: 1 }} />
              </Grid>
            )}
        </Grid>
      </Box>
      <Box>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "20px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                Item
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                W/P/D
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "right",
                }}
              >
                Qty
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "right",
                }}
              >
                Rate
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "right",
                }}
              >
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {cartItems.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textWrap: "nowrap",
                    maxWidth: "180px",
                  }}
                >
                  {item.MENUNAME}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {/* Replace W/P/D logic if needed */}
                  {item.STATUS || "F"}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "right",
                  }}
                >
                  {item.QTY}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "right",
                  }}
                >
                  {formatPrice(item.RATE)}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "right",
                  }}
                >
                  {formatPrice(item.AMOUNT)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>

      <div>
        {filteredPriceDetails.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 1,
              ...(item.highlight && {
                fontWeight: 600,
              }),
            }}
          >
            <Typography
              variant={item.highlight ? "h6" : "body2"}
              sx={{ color: item.highlight ? "black" : "inherit" }}
            >
              {item.label}
            </Typography>
            <Typography
              variant={item.highlight ? "h6" : "body2"}
              sx={{ color: item.highlight ? "black" : "inherit" }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </div>
      <Divider sx={{ marginY: 1 }} />
      {mappedOptions.has(22) && (
        <div>
          {taxnchargeDetails
            .sort((a, b) => a.cttype.localeCompare(b.cttype))
            .map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 0,
                  ...(item.highlight && {
                    fontWeight: 400,
                  }),
                }}
              >
                <Typography
                  variant={item.highlight ? "h6" : "body2"}
                  sx={{
                    color: item.highlight ? "black" : "inherit",
                    fontSize: 12,
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant={item.highlight ? "h6" : "body2"}
                  sx={{
                    color: item.highlight ? "black" : "inherit",
                    fontSize: 12,
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            ))}
        </div>
      )}
      <Divider sx={{ marginY: 1 }} />
    </>
  );
}

export default CashReceiptBodyA4;
